import { deserialize, identifier, list, object, serializable } from "serializr";
import { IJsonObject } from "../../api";
import { Bundle } from "../bundle/Bundle";

interface IProps {
	id?: number;
	code?: string;
	name?: string;
	bundles?: Bundle[];
	active?: boolean;
}

export class Product {
	public static fromJson(json: IJsonObject): Product {
		return deserialize(Product, json);
	}

	public static fromJsonArray(json: IJsonObject[]): Product[] {
		return json.map((product: IJsonObject) => this.fromJson(product));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable
	public code: string;

	@serializable
	public name: string;

	@serializable(list(object(Bundle)))
	public bundles: Bundle[];

	// Inactive products are hidden from my.velsoft's catalogue
	@serializable
	public active: boolean;

	constructor({
		id = 0,
		code = "",
		name = "",
		bundles = [],
		active = true,
	}: IProps = {}) {
		this.id = id;
		this.code = code;
		this.name = name;
		this.bundles = bundles;
		this.active = active;
	}
}
